import { ApiStatusError, autoRelogin, login } from "./utils";
import { Modal, message } from "@ss/mtd-react";

const globalErrorHandler = error => {
    if (error instanceof ApiStatusError) {
        if (error.errorCode === 401) {
            Modal.error({
                message: "登录信息失效啦，刷新一下吧~",
                onOk: () => {
                    login();
                }
            });
        } else {
            message.error({
                message: error.message
            });
        }
    } else {
        // 过滤手动abort的请求异常
        if (
            error.name === "AbortError" &&
            error.code === DOMException.ABORT_ERR
        ) {
            return;
        }
        message.error({
            message:
                error.message || "System error, please refresh and try again"
        });
    }
};

window.addEventListener("unhandledrejection", ({ reason }) =>
    globalErrorHandler(reason)
);

export default globalErrorHandler;
